// extracted by mini-css-extract-plugin
module.exports = {"new_line":"SurveyList_new_line__1oBvs"};